import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { delay } from 'rxjs/operators';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService, DateUtils } from 'ng-jhipster';


import { ITEMS_PER_PAGE, Principal, CRUD_ACTIONS, DateUtilities } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

import { NgbDatepickerConfig, NgbDateParserFormatter, NgbTabChangeEvent, NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { FileUploader } from 'ng2-file-upload';

import { Event, EventStatus } from './event.model';
import { EventService } from './event.service';
import { EventUtilService } from './event.util.service';
import { EventReservation } from '../event-reservation';
import { EventReservationService } from '../event-reservation/event-reservation.service';
import { StudentService } from '../student/student.service';
import { Student } from '../student/student.model';
import { BackOfficeService } from '../../shared';

@Component({
    selector: 'jhi-event',
    templateUrl: './event-detail.component.html'
})
export class EventDetailComponent implements OnInit, OnDestroy {

    private showMore: boolean;
    // variables for the image uploader
    uploader: FileUploader;
    hasBaseDropZoneOver: boolean;
    hasAnotherDropZoneOver: boolean;

    // variables for the tabs
    @ViewChild('tabs')
    tabSet: NgbTabset;
    currentTab: string;
    hasEventAdminRights: boolean = false;
    hasTeacherRights: boolean = false;

    eventId: number;
    event: Event;
    tempImageUrl: string;
    eventPublicUrl: string;
    private eventSubscription: any;
    private eventModifiedSubscription: any;
    private eventParticipantsListModifiedSubscription: any;

    private previousPage: String;

    eventReservations: EventReservation[];
    participantsCount: number;

    currentStudent: Student;
    currentStudentIsParticipant: boolean = false;
    currentStudentReservationHasPayedOnline: boolean = false;

    previousEvenStatus: EventStatus;

    // Variables to handle checkout
    public checkoutURLStatus: string;
    public comesFromSuccessCheckoutSession: boolean;
    public comesFromCancelCheckoutSession: boolean;
    private readonly CHECKOUT_SUCCESS = 'success';
    private readonly CHECKOUT_CANCEL = 'cancel';

    // variables to handle book and pay later
    public showBookAndPayLaterSucessMessage: boolean;
    public showBookFreeEventSuccessMessage: boolean;
    public showEventNotFoundMessage: boolean;

    // variables for the copy to clipboard functionality
    copyTooltip: string = 'Click to copy';

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private eventManager: EventManager,
        private alertService: AlertService,
        private dateUtils: DateUtils,
        private parseLinks: ParseLinks,
        private paginationUtil: PaginationUtil,
        private languageService: JhiLanguageService,
        private paginationConfig: PaginationConfig,
        private principal: Principal,
        private eventService: EventService,
        private eventReservationService: EventReservationService,
        private studentService: StudentService,
        private router: Router,
        private route: ActivatedRoute,
        private eventUtilService: EventUtilService,
        private backofficeService: BackOfficeService
    ) {
        this.jhiLanguageService.setLocations(['event', 'eventStatus',
                                              'eventCategory', 'eventReservation',
                                              'eventReservationStatus',
                                              'payment', 'paymentItem', 'paymentType']);
    }

    ngOnInit() {
        this.tempImageUrl = '';
        this.eventReservations = [];
        this.showBookAndPayLaterSucessMessage = false;
        this.showBookFreeEventSuccessMessage = false;
        this.showEventNotFoundMessage = false;

        this.principal.identity().then((account) => {
            this.studentService.getCurrent().subscribe((student: any) => {
                this.currentStudent = student;
                this.loadCurrentStudentReservation(this.eventId);
            });
        });

        this.principal
            .hasAnyAuthority(['ROLE_SCHOOL_ADMIN'])
            .then((response) => {
                this.hasEventAdminRights = response;
            });

        this.principal
            .hasAnyAuthority(['ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER'])
            .then((response) => {
                this.hasTeacherRights = response;
            });

        this.eventSubscription = this.route.params.subscribe(params => {
            this.eventId = params['id'];
            this.initUploader(this.eventId) ;
            this.previousPage = params['previousPage'];
            this.checkoutURLStatus = this.route.snapshot.queryParams['checkout']
            ?  this.route.snapshot.queryParams['checkout']
            : null;
        });

        this.eventModifiedSubscription = this.eventManager
            .subscribe('eventListModification',
            (response) => this.event = response['content']['content']);

        this.eventParticipantsListModifiedSubscription = this.eventManager
        .subscribe('eventParticipantsListModification',
        (response) => this.handleActionResult(response.content));

        this.loadEvent(this.eventId);
        this.loadParticipantsCount(this.eventId);
    }

    loadEvent(eventId: number) {
        this.eventService.find(eventId).subscribe(event => {
            this.event = event;
            this.eventPublicUrl = this.eventService.getPublicUrl(eventId);
        }, (res: HttpErrorResponse) => {
            this.showEventNotFoundMessage = true;
        });
    }

    loadParticipants(eventId: number) {
        this.eventReservationService.count({
                query: 'event.id:' + eventId
            })
            .pipe(delay(250))
            .subscribe(
                (res: number) => {
                    this.participantsCount = res;

                    if (!res || res <= 0) {
                        this.eventReservations = [];

                        return;
                    }

                    this.eventReservationService.search({
                        query: 'event.id:' + eventId
                    })
                    .subscribe(
                        (eventReservations: HttpResponse<EventReservation[]>) => {
                            let reservations = eventReservations.body.sort((a, b) => {
                                if (a && a.student && a.student.user && a.student.user.firstName &&
                                    b && b.student && b.student.user && b.student.user.firstName
                                ) {
                                    return a.student.user.firstName.localeCompare(b.student.user.firstName);
                                }
                                return 1;
                            });
                            this.eventReservations = reservations;
                        }
                    );
                },
                (res: HttpErrorResponse) => {
                    this.onError(res);
                }
            );

    }

    loadParticipantsCount(eventId: number) {
        this.eventReservationService.count({
                query: 'event.id:' + eventId
            })
            .subscribe(
                (res: number) => {
                    this.participantsCount = res;
                },
                (res: HttpErrorResponse) => {
                    this.onError(res);
                }
            );

    }

    loadCurrentStudentReservation(eventId: number) {
        this.eventReservationService.search({
            query: 'event.id:' + eventId + ' AND student.id:' + this.currentStudent.id
        })
        .subscribe(
            (eventReservations: HttpResponse<EventReservation[]>) => {
                if (eventReservations.body.length > 0) {
                    this.currentStudentIsParticipant = true;

                    eventReservations.body.forEach(eventReservation => {
                        if (eventReservation.backofficeSessionId) {
                            this.currentStudentReservationHasPayedOnline = true;
                        }
                    });
                }

                this.handleReservationCheckoutMessage();
            }
        );
    }

    initUploader (eventId: number) {
         // we create the uploader
         this.uploader = this.eventService.getNewUploader(eventId);
         this.hasBaseDropZoneOver = false;
         this.hasAnotherDropZoneOver = false;
         this.uploader.response
                         .subscribe( res => {
                            this.event.imageUrl = res;
                         });
    }

    private handleReservationCheckoutMessage() {
        if (this.checkoutURLStatus === this.CHECKOUT_CANCEL ) {
            this.comesFromCancelCheckoutSession = true;
            return;
        }

        if (this.checkoutURLStatus === this.CHECKOUT_SUCCESS ) {
            if (this.currentStudentIsParticipant && this.currentStudentReservationHasPayedOnline) {
                this.comesFromSuccessCheckoutSession = true;
                return;
            }
        }
    }

    updateImage() {
        this.event.imageUrl = this.tempImageUrl;
        this.eventService.update(this.event).subscribe((res: Event) => {
            this.event = res;
            this.tempImageUrl = '';
            this.uploader.clearQueue();
        }, (res: HttpErrorResponse) => this.onImageError(res));
    }

    deleteImage() {
        this.event.imageUrl = '';
        this.eventService.update(this.event).subscribe((res: Event) => {
            this.event = res;
            this.tempImageUrl = '';
            this.uploader.clearQueue();
        }, (res: HttpErrorResponse) => this.onImageError(res));
    }

    // This functionality is to allow to create a reservation and a checkout session to pay online
    createEventReservation() {
        let eventReservation: EventReservation = new EventReservation();
        eventReservation.event = this.event;
        eventReservation.student = this.currentStudent;
        eventReservation.school = this.event.school;
        eventReservation.payedExternally = false;

        if (this.event.free || this.event.standardUnitPrice <= 0 ) {
            eventReservation.price = this.calculatePriceForReservation(eventReservation);
            this.eventReservationService.create (eventReservation)
            .subscribe ((createdReservation: EventReservation) => {
                this.currentStudentIsParticipant = true;
                this.showBookFreeEventSuccessMessage = true;
            }, (error: HttpErrorResponse) => {
                this.onError(error);
            });

            // we do not need to call the payment system if the price is 0
            return;
        }
        this.backofficeService
            .createEventReservationWithCheckOutSession(eventReservation)
            .subscribe((chechoutUrl: string) => {
            // we open the checkout session in same browser so the user can pay
            window.location.href = chechoutUrl;
        });
    }

    // This functionality is to allow to create a reservation and allow to pay later
    createEventReservationAndAllowToPayLater() {
        let eventReservation: EventReservation = new EventReservation();
        eventReservation.event = this.event;
        eventReservation.student = this.currentStudent;
        eventReservation.school = this.event.school;
        eventReservation.payedExternally = false;

        eventReservation.price = this.calculatePriceForReservation(eventReservation);

        this.eventReservationService.createAndPayLater (eventReservation)
        .subscribe ((createdReservation: EventReservation) => {
            this.currentStudentIsParticipant = true;
            this.showBookAndPayLaterSucessMessage = true;
        }, (error: HttpErrorResponse) => {
            this.onError(error);
        });
    }

    private calculatePriceForReservation(reservation: EventReservation): number {
        if (this.event.free || this.event.standardUnitPrice <= 0) {
            return 0;
        }

        return this.event.standardUnitPrice;
    }

    disableBookButton(): boolean {
        if (!this.currentStudent || !this.event) {
            return true;
        }

        const finalizedStatus: any = 'FINALIZED';
        const cancelledStatus: any = 'CANCELLED';
        const draftStatus: any = 'DRAFT';

        if (this.event.status === finalizedStatus) {
            return true;
        }

        if (this.event.status === cancelledStatus) {
            return true;
        }

        if (this.event.status === draftStatus) {
            return true;
        }

        if (this.currentStudentIsParticipant) {
            return true;
        }

        if (!this.currentStudent.acceptOnlinePayments) {
            return true;
        }

        if (!this.event.acceptOnlinePayments) {
            return true;
        }

        if (!this.event.free) {
            if (!this.event.backOfficeUnitPriceId) {
                return true;
            }

            if (this.event.standardUnitPrice <= 0) {
                return true;
            }

        }

        return false;
    }

    disableBookAndPayLaterButton(): boolean {
        if (!this.currentStudent || !this.event) {
            return true;
        }

        const finalizedStatus: any = 'FINALIZED';
        const cancelledStatus: any = 'CANCELLED';
        const draftStatus: any = 'DRAFT';

        if (this.event.status === finalizedStatus) {
            return true;
        }

        if (this.event.status === cancelledStatus) {
            return true;
        }

        if (this.event.status === draftStatus) {
            return true;
        }

        if (this.currentStudentIsParticipant) {
            return true;
        }

        if (!this.event.free) {
            if (this.event.standardUnitPrice <= 0) {
                return true;
            }
        }

        return false;
    }

    ngOnDestroy() {
        this.eventSubscription.unsubscribe();
        this.eventModifiedSubscription.unsubscribe();
        this.eventParticipantsListModifiedSubscription.unsubscribe();
    }

    public onSelectChange(event: NgbTabChangeEvent) {
            this.currentTab = event.nextId;
            this.loadTab(event.nextId);
    }

    loadTab(tabId: string) {
        switch (tabId) {
            case 'event-info-tab':
                this.loadEvent(this.eventId);
            break;
            case 'event-participants-tab':
                this.loadParticipants(this.eventId);
            break;
            case 'event-image-tab':
                this.tempImageUrl = '';
            break;
           }
    }

    updateEventStatus(status: EventStatus) {
        this.previousEvenStatus = this.event.status;
        this.event.status = status;
        this.eventService.update(this.event).subscribe((res: Event) => {
            this.event = res;
        }, (res: HttpErrorResponse) => this.onStatusUpdateError(res));
    };

     // methods for the image uploader
    public fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    public fileOverAnother(e: any): void {
        this.hasAnotherDropZoneOver = e;
    }

    private handleActionResult(result: { action: string, content: any }) {
        let entity: any = result.content;
        let action: String = result.action;
        let found: boolean = false;

        this.eventReservations.forEach((item, i) => {
            if (item.id === entity.id) {
                found = true;
                switch (action) {
                    case CRUD_ACTIONS.UPDATE:
                        this.eventReservations[i] = entity;
                        break;
                    case CRUD_ACTIONS.DELETE:
                        this.eventReservations.splice(i, 1);
                        break;
                }
            }
        });

        if (!found && action === CRUD_ACTIONS.CREATE) {
            this.eventReservations.push(entity);
        }
    }

    previousState() {
        window.history.back();
    }

    private onStatusUpdateError(error: HttpErrorResponse, lessonId?: any) {
        this.event.status = this.previousEvenStatus;
        this.alertService.error(error.error, null, null);
    }

    private onError(error: HttpErrorResponse, lessonId?: any) {
        this.alertService.error(error.error, null, null);
    }

    private onImageError(error: HttpErrorResponse, lessonId?: any) {
        this.tempImageUrl = '';
        this.event.imageUrl = '';
        this.alertService.error(error.error, null, null);
    }

    getStatusBadgeClass(status: string): string {
        return this.eventUtilService.getStatusBadgeClass(status);
    }

    copyToClipboard(text: string): void {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed'; // Avoid scrolling to bottom
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);
        textarea.select();

        try {
          const successful = document.execCommand('copy');
          this.copyTooltip = successful ? 'Copied!' : 'Copy failed';
        } catch (err) {
          this.copyTooltip = 'Copy failed';
        }

        document.body.removeChild(textarea);
    }

    resetTooltip(): void {
        this.copyTooltip = 'Click to copy';
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event-detail.component.ts